<template name="dialog-confirm">
	<div class="product-confirm-dialog">
		<el-dialog
		  title="团购商品"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false"
		>
			<div class="pitem" v-for="item in list">
				<img :src="item.cover" :alt="item.title" class="cover">
				<div class="content">
					<div class="title">{{item.title}}</div>
					<div class="price-box">
						<div class="price">¥{{item.event_price}}</div>
						<div class="quantity">库存: {{item.quantity}}</div>
					</div>
				</div>
			</div>
		
		</el-dialog>
	</div>
</template>

<script>
	import {
		getProductList
	} from '@/api/event';
	export default {
		data() {
			return {
				list:[]
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			event_id: {
				type: Number,
				default: 0,
			},
		},
		watch:{
			show: function(newVal, oldVal){
				if(newVal){
					this.getInfo();
				}
			}
		},
		methods: {
			close() {
				this.list = [];
				this.$emit('close');
			},
			getInfo() {
				getProductList({
					event_id: this.event_id
				}).then(res => {
					if (res.code == 0) {
						this.list = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			}
		},
		mounted() {
		}
	}
</script>

<style scoped>
	.product-confirm-dialog .el-dialog__body {
		padding-top: 0;
		padding-bottom: 16px;
		height: 440px;
		overflow-x: auto;
	}
	.product-confirm-dialog .el-dialog {
		width: 567px;
	}
	
	.pitem{
		display: -webkit-flex; /* Safari */
		display: flex;
		align-items: center;
		padding: 10px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.pitem .cover{
		width: 40px;
		height: 40px;
		border-radius: 2px;
		object-fit: cover;
		display: block;
	}
	
	.pitem .content{
		margin-left: 10px;
	}
	
	
	.pitem .title{
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		width: 476px;
	}
	
	.pitem .price-box{
		display: -webkit-flex; /* Safari */
		display: flex;
		align-items: center;
		margin-top: 4px;
	}
	.pitem .price-box .price{
		font-size: 14px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #F56C6C;
	}
	.pitem .price-box .quantity{
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		margin-left: 30px;
	}
</style>